import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const paginationProps = buildProps({
  background: {
    type: Boolean,
    default: false,
  },
  pageSizes: {
    type: definePropType<number[]>(Array),
    default: () => [20, 50, 100, 200, 500],
  },
} as const);

export type PaginationProps = ExtractPropTypes<typeof paginationProps>;
